<script setup lang="ts">
/**
 * MethodSection —— 解决方法单卡（F12，type=method，1 卡 = 1 Section）。
 *
 * 与 `ProblemSection` 同模式（`GridCard` + `<DetailMoreLink>`），仅 type
 * 不同（`data-section-type` 由 `props.section.type` 驱动）。复用 `GridCard`
 * 通用卡片组件（issue：可与 ProblemSection 共享底层 / 子组件）。
 */
import GridCard from './GridCard.vue';
import type { SectionComponentProps } from './section-props';

const props = defineProps<SectionComponentProps>();
</script>

<template>
  <GridCard
    :data-section-type="props.section.type"
    :title="props.section.title"
    :summary="props.section.summary"
    :show-draft-badge="props.showDraftBadge"
  >
  </GridCard>
</template>
